module.exports = __webpack_public_path__ + "img/join-banner.1e6fac99.jpg";